import { render, staticRenderFns } from "./iosSelect.vue?vue&type=template&id=d704a852&scoped=true"
import script from "./iosSelect.vue?vue&type=script&lang=js"
export * from "./iosSelect.vue?vue&type=script&lang=js"
import style0 from "./iosSelect.vue?vue&type=style&index=0&id=d704a852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d704a852",
  null
  
)

export default component.exports